import { render, staticRenderFns } from "./onCommission.vue?vue&type=template&id=36795040&scoped=true&"
import script from "./onCommission.vue?vue&type=script&lang=js&"
export * from "./onCommission.vue?vue&type=script&lang=js&"
import style0 from "./onCommission.vue?vue&type=style&index=0&id=36795040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36795040",
  null
  
)

export default component.exports